
<template>
  <div>
    <v-data-table
      elevation="0"
      :headers="headers"
      :items="items"
      hide-default-footer
      item-key="name"
    >
      <template v-slot:item.due_date="{item}">
        {{ item.payment_description == 'Permuta' ? '-' : item.due_date }}
      </template>
      <template v-slot:item.idx="{item,index}">
        {{ item.id ? index + 1 : item.idx }}
      </template>
      <template v-slot:item.status="{item,index}">
        <v-chip :color="mapStatus(item).color" x-small class="ml-n0 white--text">
          {{ mapStatus(item).text }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{item}">

        <div class="d-flex align-center">
          <div v-if="item.payment_description == 'Boleto' && false" class="pl-3" v-f>
            <v-btn icon small @click="$emit('openBill', item)" :disabled="order.order_bills.length != order.vrt_transactions.length || order.order_bills.length == 0">
              <v-icon size="20">mdi-eye</v-icon>
            </v-btn>
          </div>
          <div v-if="item.payment_description == 'Pix'" class="pl-3">
            <v-btn icon small><v-icon size="20">mdi-qrcode</v-icon></v-btn>
          </div>
        </div>
        
      </template>
      <template v-slot:item.ammount="{item}">
        {{ item.ammount.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}
      </template>
      <template v-slot:item.ammount_payed="{item}">
        {{ item.ammount_payed.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'PaymentTable',
  //mixins: [ validations ],
  components: {
    //ComponentName: () => import(''),
  },
  props: {
    items: {
      type: Array,
      default: []
    },
    headers: {
      type: Array,
      default: []
    },
    order: {
      type: Object,
      default: {}
    },
    
  },
  data() {
    return {
      mapStatus(item){
      if(item.ammount == item.ammount_payed){
        return {text: 'Pago', color: 'success'}
      }else if(item.ammount_payed == 0){
        return {text: 'Em aberto', color: 'primary'}
      }else if(item.ammount_payed < item.ammount && item.ammount_payed > 0){
        return {text: 'Parcialmente pago', color: 'orange'}
      }else if(!item.payed){
        return {text: 'Em aberto', color: 'primary'}
      }else if(item.payed){
        return {text: 'Pagamento antecipado', color: 'success'}
      }
    },
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>